import Feathers from './feathers'

class Advertisement extends Feathers {
    getAdvertisement (topicId,code) {
        return this.request({
            url: `${ this.base }topic/compilation/article/topByCategory?topicId=${topicId}&top=100&code=${code}`
        })
    }
}

export default Advertisement
